var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ArrowBack, CalendarToday, Search } from '@mui/icons-material';
import { Avatar, Chip, CircularProgress } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { CustomerEditIcon } from '../../../assets/customIcons';
import { ReactComponent as LocationIcon } from '../../../assets/images/LocationIcon.svg';
import { ReactComponent as MailIcon } from '../../../assets/images/mailSvg.svg';
import { DynamicFormBuilderContainer } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container';
import { FormItemTypes } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
import { LOCAL_STORAGE_KEYS } from '../../../constants';
import { showSurface } from '../../../redux/awaitedSurfacesSlice';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { secondary } from '../../../theme/colors';
import { getLocalStorageItem } from '../../../utils/storageHelper';
import SlotSelector, { StartSlotsDate } from '../../crm/dashboard/components/slotsSelector';
import ServiceHistory from '../components/serviceHistry';
import { appointmentInstallBaseDetails } from '../services/apiCalls';
import { AppointmentKeys } from '../services/entity';
import EditCustomerdetails from '../../customerV3/Pages/editCustomerdetails';
import { setState } from '../../../redux/crudSlice';
var CreateAppointment = function (props) {
    var _getLocalStorageItem$, _getLocalStorageItem;
    var request = props.request, view = props.view;
    var searchParams = useSearchParams()[0];
    var crud = useAppSelector(function (state) { return state.crud; });
    var dispatch = useAppDispatch();
    var queryVin = searchParams.get('vin');
    var getInstallbase = function (state, value) { return __awaiter(void 0, void 0, void 0, function () {
        var _res, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(state !== null && state !== void 0 && state.Key && state !== null && state !== void 0 && state.Value)) return [3 /*break*/, 2];
                    return [4 /*yield*/, appointmentInstallBaseDetails({
                            request: {
                                Key: state === null || state === void 0 ? void 0 : state.Key,
                                Value: state === null || state === void 0 ? void 0 : state.Value
                            }
                        })];
                case 1:
                    res = _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/, (_res = res) === null || _res === void 0 ? void 0 : _res.data];
            }
        });
    }); };
    var openServiceHistory = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(showSurface({
                        type: 'Drawer',
                        Component: ServiceHistory,
                        componentProps: {
                            message: "Are you sure you want to delete this record?"
                        },
                        containerProps: {
                            PaperProps: {
                                sx: {
                                    width: {
                                        xs: '100%',
                                        sm: '400px'
                                    }
                                }
                            }
                        }
                    }))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var openEditProfile = function () { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(showSurface({
                        type: 'Dialog',
                        Component: EditCustomerdetails,
                        containerProps: {
                            fullWidth: true,
                            maxWidth: 'sm'
                        }
                    }))];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var searchType = [{
            id: 'RegistrationNo',
            label: 'Reg. No'
        }, {
            id: 'VinNo',
            label: 'Vin. No'
        }, {
            id: 'Mobile',
            label: 'Mobile'
        }, {
            id: 'Email',
            label: 'Email'
        }];
    var onSerachChange = function () {
        dispatch(setState({
            key: "installBaseDetails",
            value: []
        }));
        dispatch(setState({
            key: "validateAppointmentData",
            value: []
        }));
    };
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: 'header',
            columnSize: 12,
            spacing: 0,
            py: 2,
            columnGap: 1,
            alignItems: 'center',
            elements: [view === 'admin' ? {
                    type: FormItemTypes.IconButton,
                    name: 'backBtn',
                    columnSize: 0,
                    children: /*#__PURE__*/ React.createElement(ArrowBack, {
                        fontSize: "small"
                    })
                } : null, {
                    type: FormItemTypes.Typography,
                    name: "header",
                    children: view === 'admin' ? "Service details" : 'Schedule appointment',
                    columnSize: 0,
                    fontSize: 'xxl',
                    fontWeight: 'strong',
                    noWrap: true
                }]
        }, view === 'admin' ? {
            type: FormItemTypes.ContainerItem,
            name: 'actions',
            columnSize: 12,
            spacing: 0,
            py: 2,
            borderBottom: '1px solid',
            borderTop: '1px solid',
            borderColor: 'secondary.200',
            bgcolor: 'secondary.100',
            elements: [{
                    type: FormItemTypes.Stack,
                    name: 'actions',
                    direction: 'row',
                    alignItems: 'center',
                    columnGap: 0.5,
                    borderRadius: 2,
                    px: 1.25,
                    py: 0.5,
                    border: '1px solid',
                    borderColor: 'secondary.300',
                    bgcolor: 'white',
                    width: '100%',
                    maxWidth: 400,
                    elements: [{
                            type: FormItemTypes.SingleSelect,
                            name: 'Key',
                            value: searchType[0].id,
                            options: searchType,
                            displayExpr: 'label',
                            variant: 'standard',
                            disableUnderline: true,
                            sx: {
                                minWidth: 90
                            },
                            columnSize: 0
                        }, {
                            type: FormItemTypes.TextInput,
                            name: 'Value',
                            columnSize: true,
                            variant: 'standard',
                            placeholder: 'Search by Reg No, VIN, Mobile, Email',
                            InputProps: {
                                disableUnderline: true
                            },
                            valueSetter: function (state, currValue, field) {
                                var _a;
                                return (_a = {},
                                    _a[field.name] = currValue === null || currValue === void 0 ? void 0 : currValue.trim(),
                                    _a);
                            }
                        }, {
                            type: FormItemTypes.IconButton,
                            name: 'searchButton',
                            columnSize: 0,
                            color: 'secondary',
                            children: crud["isLoading".concat(AppointmentKeys.InstallBase)] === 'loading' ? /*#__PURE__*/ React.createElement(CircularProgress, {
                                color: "secondary",
                                size: 20
                            }) : /*#__PURE__*/ React.createElement(Search, {
                                color: "secondary"
                            }),
                            setFormState: getInstallbase
                        }]
                }]
        } : null, {
            type: FormItemTypes.ContainerItem,
            name: 'customer_vehicle_details',
            columnSize: 12,
            elements: [{
                    type: FormItemTypes.CardComponent,
                    label: 'Customer details',
                    name: '',
                    value: null,
                    xs: 12,
                    sm: 12,
                    md: 6,
                    elements: [{
                            type: FormItemTypes.Custom,
                            name: '',
                            value: null,
                            columnSize: 0,
                            element: function () { /*#__PURE__*/ return React.createElement(Avatar, null); }
                        }, {
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            value: null,
                            columnSize: true,
                            spacing: 0,
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: 'CustomerName',
                                    value: '-',
                                    fontWeight: 'medium',
                                    columnSize: 12
                                }, {
                                    type: FormItemTypes.Typography,
                                    value: '-',
                                    name: 'Mobile',
                                    color: 'secondary',
                                    fontSize: 'sm',
                                    columnSize: 12
                                }]
                        }, view === 'admin' ? {
                            type: FormItemTypes.IconButton,
                            name: '',
                            value: null,
                            columnSize: 0,
                            size: 'medium',
                            children: /*#__PURE__*/ React.createElement(CustomerEditIcon, {
                                fontSize: "small",
                                color: "secondary"
                            })
                        } : null, {
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: 12,
                            spacing: 0,
                            rowGap: 1.5,
                            elements: [{
                                    type: FormItemTypes.Divider,
                                    name: '',
                                    value: null,
                                    columnSize: 12
                                }, {
                                    type: FormItemTypes.ContainerItem,
                                    name: 'customer-email',
                                    columnSize: 12,
                                    spacing: 0,
                                    columnGap: 1,
                                    elements: [{
                                            type: FormItemTypes.Custom,
                                            name: '',
                                            value: null,
                                            columnSize: 0,
                                            element: function () { /*#__PURE__*/ return React.createElement(MailIcon, {
                                                color: secondary[500],
                                                width: 20,
                                                height: 20
                                            }); },
                                            containerProps: {
                                                display: 'inline-flex',
                                                alignItems: 'center'
                                            }
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'Email',
                                            value: '-',
                                            columnSize: true,
                                            color: 'secondary'
                                        }]
                                }, {
                                    type: FormItemTypes.ContainerItem,
                                    name: 'customer-address',
                                    columnSize: 12,
                                    spacing: 0,
                                    columnGap: 1,
                                    elements: [{
                                            type: FormItemTypes.Custom,
                                            name: '',
                                            value: null,
                                            columnSize: 0,
                                            element: function () { /*#__PURE__*/ return React.createElement(LocationIcon, {
                                                color: secondary[500],
                                                width: 20,
                                                height: 20
                                            }); },
                                            containerProps: {
                                                display: 'inline-flex',
                                                alignItems: 'center'
                                            }
                                        }, {
                                            type: FormItemTypes.Typography,
                                            name: 'Address',
                                            value: '-',
                                            columnSize: true,
                                            color: 'secondary'
                                        }]
                                }]
                        }]
                }, {
                    type: FormItemTypes.CardComponent,
                    name: '',
                    label: 'Vehicle details',
                    xs: 12,
                    sm: 12,
                    md: 6,
                    contentProps: {
                        spacing: 0,
                        rowGap: 2
                    },
                    elements: [view === 'admin' ? {
                            type: FormItemTypes.CheckBox,
                            name: 'SelectVehicle',
                            label: null,
                            value: false,
                            size: 'small',
                            columnSize: 0,
                            formControlLabelProps: {
                                sx: {
                                    m: 0
                                }
                            }
                        } : null, {
                            type: FormItemTypes.ContainerItem,
                            name: 'CustomerDetails',
                            columnSize: true,
                            spacing: 0,
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: 'RegistrationNo',
                                    value: '-',
                                    fontWeight: 'medium',
                                    fontSize: 'lg',
                                    columnSize: 12
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: 'Product',
                                    value: '-',
                                    color: 'secondary',
                                    columnSize: 12
                                }]
                        }, {
                            type: FormItemTypes.CardComponent,
                            name: '',
                            columnSize: 12,
                            contentProps: {
                                spacing: 0.5
                            },
                            sx: {
                                p: 1.5,
                                bgcolor: 'secondary.50',
                                border: 'none'
                            },
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    label: 'Engine No. :',
                                    name: 'EngineNo',
                                    value: '-',
                                    columnSize: 12,
                                    fontWeight: 'medium',
                                    containerProps: {
                                        container: true,
                                        flexDirection: 'row',
                                        justifyContent: 'space-between',
                                        alignItems: 'center'
                                    },
                                    labelTypographyProps: {
                                        mb: 0
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    label: 'Chassis No. :',
                                    name: 'ChassisNo',
                                    value: '-',
                                    columnSize: 12,
                                    fontWeight: 'medium',
                                    containerProps: {
                                        container: true,
                                        flexDirection: 'row',
                                        justifyContent: 'space-between',
                                        alignItems: 'center'
                                    },
                                    labelTypographyProps: {
                                        mb: 0
                                    }
                                }, {
                                    type: FormItemTypes.Typography,
                                    label: 'Date of Sale :',
                                    name: 'DateOfSale',
                                    value: '-',
                                    columnSize: 12,
                                    fontWeight: 'medium',
                                    containerProps: {
                                        container: true,
                                        flexDirection: 'row',
                                        justifyContent: 'space-between',
                                        alignItems: 'center'
                                    },
                                    labelTypographyProps: {
                                        mb: 0
                                    }
                                }]
                        }]
                }]
        }, {
            type: FormItemTypes.CardComponent,
            label: 'Service Details',
            name: 'ServiceDetails',
            value: null,
            columnSize: 12,
            elements: [view === 'customer' ? {
                    type: FormItemTypes.SearchSelect,
                    name: 'BranchId',
                    label: 'Service branch',
                    placeholder: 'Select dealer',
                    options: (_getLocalStorageItem$ = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.data) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.Branches) !== null && _getLocalStorageItem$ !== void 0 ? _getLocalStorageItem$ : [],
                    valueExpr: 'OrganizationId',
                    displayExpr: 'OrganizationName',
                    required: true
                } : null, {
                    type: FormItemTypes.SearchSelect,
                    label: 'Service Type',
                    name: 'ServiceType',
                    value: null,
                    required: view !== 'customer',
                    options: [],
                    displayExpr: 'type'
                }, {
                    type: FormItemTypes.NumberInput,
                    label: 'Odometer Reading',
                    name: 'Odometer',
                    value: null,
                    required: view !== 'customer'
                }, view !== 'customer' ? {
                    type: FormItemTypes.TextInput,
                    label: 'Service Advisor',
                    name: 'ServiceAdvisor',
                    value: null,
                    placeholder: 'MS Dhoni',
                    disabled: true
                } : null]
        }, view !== 'customer' ? {
            type: FormItemTypes.CardComponent,
            label: 'Other details',
            name: 'OtherDetails',
            value: null,
            columnSize: 12,
            elements: [{
                    type: FormItemTypes.SearchSelect,
                    label: 'Campaign',
                    name: 'CampaignType',
                    value: null,
                    md: 4,
                    lg: 3,
                    options: [],
                    displayExpr: 'label'
                }]
        } : null, {
            type: FormItemTypes.CardComponent,
            name: '',
            label: 'Date & time slot',
            headerProps: {
                subheader: 'Select appointment date and time slot',
                subheaderTypographyProps: {
                    color: 'text.tertiary'
                }
            },
            variant: 'outlined',
            columnSize: 12,
            elements: [{
                    type: FormItemTypes.TextInput,
                    name: 'SlotDateTime',
                    placeholder: 'Select date & time',
                    InputProps: {
                        readOnly: true,
                        startAdornment: /*#__PURE__*/ React.createElement(CalendarToday, {
                            color: "secondary",
                            fontSize: "small",
                            sx: {
                                mr: 1
                            }
                        })
                    },
                    validator: function (value, state) {
                        var _state$SelectedTimeSl;
                        return !(state !== null && state !== void 0 && state.SelectDaySlot && "".concat((_state$SelectedTimeSl = state === null || state === void 0 ? void 0 : state.SelectedTimeSlotId) !== null && _state$SelectedTimeSl !== void 0 ? _state$SelectedTimeSl : '')) ? 'Please select appointment date & time slot' : undefined;
                    }
                }, {
                    type: FormItemTypes.Custom,
                    name: 'SelectDaySlot',
                    columnSize: 12,
                    element: SlotSelector,
                    setFormState: function (state, value) { return ({
                        SlotDateTime: value ? StartSlotsDate.add(value.index, 'days').format('DD MMM, YYYY') : '',
                        SelectedTimeSlotId: null
                    }); }
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    spacing: 2,
                    elements: new Array(8).fill(0).map(function (field, i) { return ({
                        type: FormItemTypes.Button,
                        xs: 6,
                        sm: 4,
                        md: 3,
                        fullWidth: true,
                        name: "".concat(i),
                        children: [StartSlotsDate.add(9 + i, 'hours').format('h:mm a'), /*#__PURE__*/ React.createElement(Chip, {
                                label: "10/10",
                                variant: "outlined",
                                color: "secondary",
                                size: "small",
                                sx: {
                                    mx: 0.5,
                                    bgcolor: secondary[50],
                                    color: 'text.primary',
                                    fontSize: 'sm',
                                    fontWeight: 'medium'
                                }
                            })],
                        setFormState: function (state) {
                            var timeSlotIndex = (state === null || state === void 0 ? void 0 : state.SelectedTimeSlotId) === i ? null : i;
                            return {
                                SelectedTimeSlotId: timeSlotIndex,
                                SlotDateTime: state !== null && state !== void 0 && state.SelectDaySlot && timeSlotIndex !== null ? StartSlotsDate.add(state.SelectDaySlot.index + 1, 'days').add(9 + timeSlotIndex, 'hours').format('DD MMM, YYYY  h:mm a') : ''
                            };
                        },
                        setFieldProps: function (state) { return ({
                            type: FormItemTypes.Button,
                            variant: (state === null || state === void 0 ? void 0 : state.SelectedTimeSlotId) === i ? 'contained' : 'outlined',
                            color: (state === null || state === void 0 ? void 0 : state.SelectedTimeSlotId) === i ? 'primary' : 'secondary'
                        }); },
                        sx: {
                            textWrap: 'nowrap',
                            fontWeight: 'medium'
                        }
                    }); })
                }]
        }, {
            type: FormItemTypes.CardComponent,
            label: view !== 'customer' ? 'Customer complaints' : 'Complaints',
            name: '',
            columnSize: 12,
            elements: [{
                    type: FormItemTypes.TextInput,
                    name: 'CustomerComplaints',
                    placeholder: 'Enter complaints',
                    columnSize: 12,
                    minRows: 4,
                    multiline: true
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            justifyContent: 'end',
            elements: [{
                    type: FormItemTypes.Divider,
                    name: '',
                    columnSize: 12,
                    sx: {
                        mx: -2
                    }
                }, {
                    type: FormItemTypes.Button,
                    name: '',
                    children: 'Schedule',
                    columnSize: 0,
                    variant: 'contained',
                    onClick: function () { return 'submit'; }
                }]
        }];
    return /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        gridProps: {
            p: 2,
            bgcolor: 'secondary.50'
        },
        mode: queryVin || request !== null && request !== void 0 && request.Value ? 'edit' : 'add',
        getFormAPI: appointmentInstallBaseDetails,
        getKey: AppointmentKeys.InstallBase,
        getRequest: queryVin ? {
            Key: 'VinNo',
            Value: queryVin
        } : request
    });
};
export default CreateAppointment;
